/*
 * Instalment maths, client side.
 *
 * Mirrors snippets/installment-amount-sb.liquid. Liquid paints the first
 * render, this repaints when the shopper changes variant, and the two must
 * agree to the cent - the figure is a regulated credit disclosure, not a
 * decoration.
 *
 * It lives here rather than inside a section so there is one copy for every
 * card that quotes an instalment. product-extra-data-sb previously carried its
 * own, and its two halves drifted apart repeatedly.
 */
window.SBInstalments = (function () {
  /**
   * @param {number} priceCents  price as Shopify stores it
   * @param {{months:number, apr:number, fee:number}} terms
   * @returns {number} the monthly amount in currency units, rounded to cents
   */
  function monthlyFor(priceCents, terms) {
    var months = terms.months || 0;
    if (months <= 0) return 0;

    var apr = terms.apr || 0;
    var fee = terms.fee || 0;
    var principal = priceCents / 100;
    var payment;

    if (apr > 0) {
      // Annuity. Rate is per instalment, not per year.
      var rate = apr / 100 / months;
      payment = (principal * rate) / (1 - Math.pow(1 + rate, -months));
    } else {
      // No rate configured means no interest to spread.
      payment = principal / months;
    }

    return Math.round((payment + fee) * 100) / 100;
  }

  /** Formats through the shop's own money_format, so the currency and
   *  separators follow the store rather than being hardcoded here. */
  function money(amount, format) {
    return format.replace(/\{\{\s*amount[\w_]*\s*\}\}/, amount.toFixed(2));
  }

  return { monthlyFor: monthlyFor, money: money };
})();
